// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1lrP5","approved":"Status_approved__2fH0_","rejected":"Status_rejected__32YZj","expired":"Status_expired__1_1Cs","label":"Status_label__Ei-eA"};